import { Action, createReducer, on } from '@ngrx/store';
import { IGenericError, ErrorResponse } from '../../../../../src/app/core/models/generic-models';
import { IRejectBankProofRequest, IRejectBankProofResponse } from '../models/bank-proof.model';
import { rejectBankProofFailure, rejectBankProofRequest, rejectBankProofResponse } from '../actions/bank-proofs.actions';
import { IRejectBankProofDocumentRequest, IRejectBankProofDocumentResponse } from '../models/bank-proof-documents.model';
import { rejectBankProofDocumentFailure, rejectBankProofDocumentRequest, rejectBankProofDocumentResponse } from '../actions/bank-proof-documents.actions';

export const rejectBankProofDocumentFeatureKey = 'rejectBankProofDocument';

export interface RejectBankProofDocumentState {
  rejectBankProofDocumentRequest: IRejectBankProofDocumentRequest;
  rejectBankProofDocumentSuccess: IRejectBankProofDocumentResponse;
  rejectBankProofDocumentFailure: IGenericError<ErrorResponse>;
}

export const initialState: RejectBankProofDocumentState = {
  rejectBankProofDocumentRequest: undefined,
  rejectBankProofDocumentSuccess: undefined,
  rejectBankProofDocumentFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(rejectBankProofDocumentRequest, (state, action) => ({
    ...state,
    rejectBankProofDocumentRequest: action.request
  })),
  on(rejectBankProofDocumentResponse, (state, action) => ({
    ...state,
    rejectBankProofDocumentSuccess: action.response
  })),
  on(rejectBankProofDocumentFailure, (state, action) => ({
    ...state,
    approveBankProofFailure: action.error
  }))
);

export const getRejectBankProofDocumentRequest = (state: RejectBankProofDocumentState) => state.rejectBankProofDocumentRequest;
export const getRejectBankProofDocumentResponse = (state: RejectBankProofDocumentState) => state.rejectBankProofDocumentSuccess;
export const getRejectBankProofDocumentFailure = (state: RejectBankProofDocumentState) => state.rejectBankProofDocumentFailure;
